/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  GetSimpleDutyRosterPeriodStatusesByIdsParams,
  SetDepartmentStatusRequest,
  SetWorkAreaStatusRequest,
  SimpleDutyRosterPeriodStatus
} from '../../model';

import { customInstance } from '../../../mutator';
import type { ErrorType , BodyType } from '../../../mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getSetWorkAreaWeekStatusUrl = () => {


  

  return `/api/PeriodStatusService/SetWorkAreaWeekStatus`
}

export const setWorkAreaWeekStatus = async (setWorkAreaStatusRequest: SetWorkAreaStatusRequest, options?: RequestInit): Promise<void> => {
  
  return customInstance<void>(getSetWorkAreaWeekStatusUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      setWorkAreaStatusRequest,)
  }
);}




export const getSetWorkAreaWeekStatusMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setWorkAreaWeekStatus>>, TError,{data: BodyType<SetWorkAreaStatusRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof setWorkAreaWeekStatus>>, TError,{data: BodyType<SetWorkAreaStatusRequest>}, TContext> => {

const mutationKey = ['setWorkAreaWeekStatus'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setWorkAreaWeekStatus>>, {data: BodyType<SetWorkAreaStatusRequest>}> = (props) => {
          const {data} = props ?? {};

          return  setWorkAreaWeekStatus(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SetWorkAreaWeekStatusMutationResult = NonNullable<Awaited<ReturnType<typeof setWorkAreaWeekStatus>>>
    export type SetWorkAreaWeekStatusMutationBody = BodyType<SetWorkAreaStatusRequest>
    export type SetWorkAreaWeekStatusMutationError = ErrorType<unknown>

    export const useSetWorkAreaWeekStatus = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setWorkAreaWeekStatus>>, TError,{data: BodyType<SetWorkAreaStatusRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setWorkAreaWeekStatus>>,
        TError,
        {data: BodyType<SetWorkAreaStatusRequest>},
        TContext
      > => {

      const mutationOptions = getSetWorkAreaWeekStatusMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getSetDepartmentWeekStatusUrl = () => {


  

  return `/api/PeriodStatusService/SetDepartmentWeekStatus`
}

export const setDepartmentWeekStatus = async (setDepartmentStatusRequest: SetDepartmentStatusRequest, options?: RequestInit): Promise<void> => {
  
  return customInstance<void>(getSetDepartmentWeekStatusUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      setDepartmentStatusRequest,)
  }
);}




export const getSetDepartmentWeekStatusMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setDepartmentWeekStatus>>, TError,{data: BodyType<SetDepartmentStatusRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof setDepartmentWeekStatus>>, TError,{data: BodyType<SetDepartmentStatusRequest>}, TContext> => {

const mutationKey = ['setDepartmentWeekStatus'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setDepartmentWeekStatus>>, {data: BodyType<SetDepartmentStatusRequest>}> = (props) => {
          const {data} = props ?? {};

          return  setDepartmentWeekStatus(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SetDepartmentWeekStatusMutationResult = NonNullable<Awaited<ReturnType<typeof setDepartmentWeekStatus>>>
    export type SetDepartmentWeekStatusMutationBody = BodyType<SetDepartmentStatusRequest>
    export type SetDepartmentWeekStatusMutationError = ErrorType<unknown>

    export const useSetDepartmentWeekStatus = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setDepartmentWeekStatus>>, TError,{data: BodyType<SetDepartmentStatusRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setDepartmentWeekStatus>>,
        TError,
        {data: BodyType<SetDepartmentStatusRequest>},
        TContext
      > => {

      const mutationOptions = getSetDepartmentWeekStatusMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getGetSimpleDutyRosterPeriodStatusesByIdsUrl = (params: GetSimpleDutyRosterPeriodStatusesByIdsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["ids"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }
      
    
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/PeriodStatusService/GetSimpleDutyRosterPeriodStatusesByIds?${stringifiedParams}` : `/api/PeriodStatusService/GetSimpleDutyRosterPeriodStatusesByIds`
}

export const getSimpleDutyRosterPeriodStatusesByIds = async (params: GetSimpleDutyRosterPeriodStatusesByIdsParams, options?: RequestInit): Promise<SimpleDutyRosterPeriodStatus[]> => {
  
  return customInstance<SimpleDutyRosterPeriodStatus[]>(getGetSimpleDutyRosterPeriodStatusesByIdsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetSimpleDutyRosterPeriodStatusesByIdsQueryKey = (params?: GetSimpleDutyRosterPeriodStatusesByIdsParams,) => {
    return [
    `/api/PeriodStatusService/GetSimpleDutyRosterPeriodStatusesByIds`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetSimpleDutyRosterPeriodStatusesByIdsQueryOptions = <TData = Awaited<ReturnType<typeof getSimpleDutyRosterPeriodStatusesByIds>>, TError = ErrorType<unknown>>(params: GetSimpleDutyRosterPeriodStatusesByIdsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimpleDutyRosterPeriodStatusesByIds>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSimpleDutyRosterPeriodStatusesByIdsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSimpleDutyRosterPeriodStatusesByIds>>> = ({ signal }) => getSimpleDutyRosterPeriodStatusesByIds(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSimpleDutyRosterPeriodStatusesByIds>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetSimpleDutyRosterPeriodStatusesByIdsQueryResult = NonNullable<Awaited<ReturnType<typeof getSimpleDutyRosterPeriodStatusesByIds>>>
export type GetSimpleDutyRosterPeriodStatusesByIdsQueryError = ErrorType<unknown>


export function useGetSimpleDutyRosterPeriodStatusesByIds<TData = Awaited<ReturnType<typeof getSimpleDutyRosterPeriodStatusesByIds>>, TError = ErrorType<unknown>>(
 params: GetSimpleDutyRosterPeriodStatusesByIdsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimpleDutyRosterPeriodStatusesByIds>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSimpleDutyRosterPeriodStatusesByIds>>,
          TError,
          Awaited<ReturnType<typeof getSimpleDutyRosterPeriodStatusesByIds>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetSimpleDutyRosterPeriodStatusesByIds<TData = Awaited<ReturnType<typeof getSimpleDutyRosterPeriodStatusesByIds>>, TError = ErrorType<unknown>>(
 params: GetSimpleDutyRosterPeriodStatusesByIdsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimpleDutyRosterPeriodStatusesByIds>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSimpleDutyRosterPeriodStatusesByIds>>,
          TError,
          Awaited<ReturnType<typeof getSimpleDutyRosterPeriodStatusesByIds>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetSimpleDutyRosterPeriodStatusesByIds<TData = Awaited<ReturnType<typeof getSimpleDutyRosterPeriodStatusesByIds>>, TError = ErrorType<unknown>>(
 params: GetSimpleDutyRosterPeriodStatusesByIdsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimpleDutyRosterPeriodStatusesByIds>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetSimpleDutyRosterPeriodStatusesByIds<TData = Awaited<ReturnType<typeof getSimpleDutyRosterPeriodStatusesByIds>>, TError = ErrorType<unknown>>(
 params: GetSimpleDutyRosterPeriodStatusesByIdsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimpleDutyRosterPeriodStatusesByIds>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetSimpleDutyRosterPeriodStatusesByIdsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetSimpleDutyRosterPeriodStatusesByIdsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getSimpleDutyRosterPeriodStatusesByIds>>, TError = ErrorType<unknown>>(params: GetSimpleDutyRosterPeriodStatusesByIdsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimpleDutyRosterPeriodStatusesByIds>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSimpleDutyRosterPeriodStatusesByIdsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSimpleDutyRosterPeriodStatusesByIds>>> = ({ signal }) => getSimpleDutyRosterPeriodStatusesByIds(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimpleDutyRosterPeriodStatusesByIds>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetSimpleDutyRosterPeriodStatusesByIdsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getSimpleDutyRosterPeriodStatusesByIds>>>
export type GetSimpleDutyRosterPeriodStatusesByIdsSuspenseQueryError = ErrorType<unknown>


export function useGetSimpleDutyRosterPeriodStatusesByIdsSuspense<TData = Awaited<ReturnType<typeof getSimpleDutyRosterPeriodStatusesByIds>>, TError = ErrorType<unknown>>(
 params: GetSimpleDutyRosterPeriodStatusesByIdsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimpleDutyRosterPeriodStatusesByIds>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetSimpleDutyRosterPeriodStatusesByIdsSuspense<TData = Awaited<ReturnType<typeof getSimpleDutyRosterPeriodStatusesByIds>>, TError = ErrorType<unknown>>(
 params: GetSimpleDutyRosterPeriodStatusesByIdsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimpleDutyRosterPeriodStatusesByIds>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetSimpleDutyRosterPeriodStatusesByIdsSuspense<TData = Awaited<ReturnType<typeof getSimpleDutyRosterPeriodStatusesByIds>>, TError = ErrorType<unknown>>(
 params: GetSimpleDutyRosterPeriodStatusesByIdsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimpleDutyRosterPeriodStatusesByIds>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetSimpleDutyRosterPeriodStatusesByIdsSuspense<TData = Awaited<ReturnType<typeof getSimpleDutyRosterPeriodStatusesByIds>>, TError = ErrorType<unknown>>(
 params: GetSimpleDutyRosterPeriodStatusesByIdsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimpleDutyRosterPeriodStatusesByIds>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetSimpleDutyRosterPeriodStatusesByIdsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



